import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useCardTypesStore } from "@stores/survey/cardTypes";
import { useSurveyAccountStore } from "@stores/survey/setup/surveyAccount";
import { useSurveyStore } from "@stores/survey/survey";
import { getCreditRules, creditsLabel } from "@utils/credits/creditRules";

export function useCardTypeAccess() {
  const { isFreemiumAccount } = storeToRefs(useSurveyAccountStore());
  const { survey } = storeToRefs(useSurveyStore());
  const { creatableTypes } = storeToRefs(useCardTypesStore());

  const aiChatCreditsRequired = computed(
    () => getCreditRules({ aiChat: true, freemiumAccount: isFreemiumAccount.value }).stepperIncrement,
  );

  const aiChatBlockedByCredits = computed(() => {
    if (!survey.value?.contract_id) return false;
    if (survey.value.credits_consumed_manual != null) return false;

    return (survey.value.credits_max ?? 0) < aiChatCreditsRequired.value;
  });

  const cardTypeDisabledReason = (cardType) => {
    if (cardType === "ai_chat_v2" && aiChatBlockedByCredits.value) {
      const required = aiChatCreditsRequired.value;
      return `You need at least ${required} ${creditsLabel(required)} allocated to this survey to add an AI Chat card.`;
    }

    return null;
  };

  const isCardTypeDisabled = (cardType) =>
    !creatableTypes.value.has(cardType) || cardTypeDisabledReason(cardType) !== null;

  return { isCardTypeDisabled, cardTypeDisabledReason };
}
